import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { ErrorDetails } from '../../authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';

export class RegisterODNUserCommand extends IRequestCommand<
  ICommandResponse,
  ErrorDetails,
  IRegisterODNUserParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.POST;
  override _commandUrl = 'odn/{carrierId}/register';
  public override setParameters(parameters: IRegisterODNUserParameters) {
    this._commandUrl = this._commandUrl.replace('{carrierId}', parameters.carrierId.toString());
    this._commandBody = parameters;
  }
}

export interface IRegisterODNUserParameters extends ICommandParameters {
  carrierId: string;
  password: string;
  userCode: string;
  userName: string;
  userId: number;
  odnCode: string;
}
